import React, { useState, useEffect } from 'react';

const gold = '#d4a843';
const border = 'rgba(212,168,67,0.15)';

export default function AdManagerTab({ backendUrl, token }) {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    title: '', type: 'banner', media_url: '', click_url: 'https://nethajiprime.com',
    duration_seconds: 15, is_active: true, monthly_rate: 0,
    expires_at: new Date(Date.now() + 30*24*60*60*1000).toISOString().slice(0,10)
  });
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const handleFileUpload = async (file) => {
    if (!file) return;
    setUploading(true);
    setUploadProgress(0);
    try {
      const ext = file.name.split('.').pop();
      const key = 'ads/' + Date.now() + '_' + Math.random().toString(36).slice(2,8) + '.' + ext;
      const presignRes = await fetch(backendUrl + '/admin/presign-upload', {
        method: 'POST', headers: { ...headers, 'Content-Type': 'application/json' },
        body: JSON.stringify({ fileName: key, contentType: file.type })
      });
      const { uploadUrl, publicUrl } = await presignRes.json();
      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.upload.onprogress = (ev) => { if (ev.lengthComputable) setUploadProgress(Math.round((ev.loaded / ev.total) * 100)); };
        xhr.onload = () => xhr.status === 200 ? resolve() : reject(new Error('Upload failed: ' + xhr.status));
        xhr.onerror = reject;
        xhr.open('PUT', uploadUrl); xhr.setRequestHeader('Content-Type', file.type); xhr.send(file);
      });
      setForm(f => ({ ...f, media_url: publicUrl }));
      setMsg('Image uploaded!');
    } catch (e) {
      setMsg('Upload error: ' + e.message);
    }
    setUploading(false);
  };

  const [globalConfig, setGlobalConfig] = useState({ ads_enabled: true, ads_exclude_premium: true, ads_frequency_cap: 30 });
  const [configSaving, setConfigSaving] = useState(false);

  useEffect(() => {
    fetch(backendUrl + '/api/ad-config').then(r=>r.json()).then(d=>setGlobalConfig(d)).catch(()=>{});
  }, [backendUrl]);

  const saveGlobalConfig = async () => {
    setConfigSaving(true);
    try {
      await fetch(backendUrl + '/api/ad-config', { method: 'POST', headers: { ...headers, 'Content-Type': 'application/json' }, body: JSON.stringify({ ads_enabled: String(globalConfig.ads_enabled), ads_exclude_premium: String(globalConfig.ads_exclude_premium), ads_frequency_cap: String(globalConfig.ads_frequency_cap) }) });
      setMsg('Global config saved!');
    } catch(e) { setMsg('Error: ' + e.message); }
    setConfigSaving(false);
  };

  const [msg, setMsg] = useState('');

  const headers = { Authorization: 'Bearer ' + token };

  const fetchAds = async () => {
    setLoading(true);
    try {
      const r = await fetch(backendUrl + '/api/ads', { headers });
      const d = await r.json();
      setAds(d.ads || []);
    } catch(e) {}
    setLoading(false);
  };

  useEffect(() => { fetchAds(); }, []);

  const handleSave = async () => {
    if (!form.title || !form.media_url) { setMsg('Title and Media URL required!'); return; }
    setSaving(true);
    try {
      const r = await fetch(backendUrl + '/api/ads', {
        method: 'POST',
        headers: { ...headers, 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, expires_at: new Date(form.expires_at).toISOString() })
      });
      const d = await r.json();
      if (d.success) { setMsg('Ad created!'); setShowForm(false); fetchAds(); }
      else setMsg('Error: ' + JSON.stringify(d));
    } catch(e) { setMsg('Error: ' + e.message); }
    setSaving(false);
  };

  const toggleActive = async (ad) => {
    await fetch(backendUrl + '/api/ads/' + ad.id, {
      method: 'PATCH', headers: { ...headers, 'Content-Type': 'application/json' },
      body: JSON.stringify({ is_active: !ad.is_active })
    });
    fetchAds();
  };

  const deleteAd = async (id) => {
    if (!window.confirm('Delete this ad?')) return;
    await fetch(backendUrl + '/api/ads/' + id, { method: 'DELETE', headers });
    fetchAds();
  };

  const typeColors = { preroll: '#FF0000', banner: '#0066cc', lband: '#9900cc', popup: '#ff6600' };
  const typeLabels = { preroll: 'Pre-roll', banner: 'Banner', lband: 'L-Band', popup: 'Popup' };
  const inp = { width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid ' + border, borderRadius: 6, padding: '8px 12px', color: '#fff', fontSize: 13, boxSizing: 'border-box' };
  const lbl = { color: 'rgba(255,255,255,0.5)', fontSize: 11, letterSpacing: 1, display: 'block', marginBottom: 4 };

  return (
    <div style={{ maxWidth: 900, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <div style={{ color: gold, fontFamily: "'Bebas Neue',sans-serif", fontSize: 22, letterSpacing: 2 }}>AD MANAGER</div>
          <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 12 }}>Create and manage ads across Nethaji Prime</div>
        </div>
        <button onClick={() => setShowForm(s => !s)} style={{ background: gold, color: '#000', border: 'none', borderRadius: 6, padding: '8px 18px', fontFamily: "'Bebas Neue',sans-serif", fontSize: 13, cursor: 'pointer' }}>
          {showForm ? 'CANCEL' : '+ NEW AD'}
        </button>
      </div>

      
      {/* Global Ad Config */}
      <div style={{ background: globalConfig.ads_enabled ? 'rgba(0,200,100,0.05)' : 'rgba(255,0,0,0.05)', border: '1px solid ' + (globalConfig.ads_enabled ? 'rgba(0,200,100,0.2)' : 'rgba(255,0,0,0.2)'), borderRadius: 10, padding: 16, marginBottom: 20 }}>
        <div style={{ color: gold, fontFamily: "'Bebas Neue',sans-serif", fontSize: 14, letterSpacing: 2, marginBottom: 12 }}>GLOBAL AD SETTINGS</div>
        <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap', alignItems: 'center' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#fff', fontSize: 13, cursor: 'pointer' }}>
            <input type="checkbox" checked={globalConfig.ads_enabled} onChange={e=>setGlobalConfig(c=>({...c,ads_enabled:e.target.checked}))} /> Ads Enabled
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#fff', fontSize: 13, cursor: 'pointer' }}>
            <input type="checkbox" checked={globalConfig.ads_exclude_premium} onChange={e=>setGlobalConfig(c=>({...c,ads_exclude_premium:e.target.checked}))} /> Skip for Premium Users
          </label>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: 12 }}>Frequency Cap (mins):</span>
            <input type="number" value={globalConfig.ads_frequency_cap} onChange={e=>setGlobalConfig(c=>({...c,ads_frequency_cap:parseInt(e.target.value)}))} style={{ width: 60, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(212,168,67,0.15)', borderRadius: 4, padding: '4px 8px', color: '#fff', fontSize: 13 }} />
          </div>
          <button onClick={saveGlobalConfig} disabled={configSaving} style={{ background: gold, color: '#000', border: 'none', borderRadius: 6, padding: '6px 16px', fontFamily: "'Bebas Neue',sans-serif", fontSize: 12, cursor: 'pointer' }}>{configSaving ? 'SAVING...' : 'SAVE'}</button>
        </div>
      </div>
{msg && <div style={{ background: 'rgba(0,200,100,0.1)', border: '1px solid rgba(0,200,100,0.3)', borderRadius: 6, padding: '8px 14px', color: '#00cc66', fontSize: 13, marginBottom: 16 }}>{msg}</div>}

      {showForm && (
        <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid ' + border, borderRadius: 10, padding: 20, marginBottom: 24 }}>
          <div style={{ color: gold, fontFamily: "'Bebas Neue',sans-serif", fontSize: 16, letterSpacing: 2, marginBottom: 16 }}>CREATE NEW AD</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
            <div><label style={lbl}>AD TITLE *</label><input value={form.title} onChange={e=>setForm(f=>({...f,title:e.target.value}))} placeholder="e.g. Diwali Sale" style={inp} /></div>
            <div><label style={lbl}>AD TYPE</label>
              <select value={form.type} onChange={e=>setForm(f=>({...f,type:e.target.value}))} style={{...inp, colorScheme:'dark'}}>
                <option value="banner" style={{background:'#1a0008',color:'#fff'}}>Banner (between rows)</option>
                <option value="preroll" style={{background:'#1a0008',color:'#fff'}}>Pre-roll (before video)</option>
                <option value="lband" style={{background:'#1a0008',color:'#fff'}}>L-Band (overlay on video)</option>
                <option value="popup" style={{background:'#1a0008',color:'#fff'}}>Popup</option>
              </select>
            </div>
            <div style={{gridColumn:'1/-1'}}>
              <label style={lbl}>MEDIA URL * (image or video)</label>
              <input value={form.media_url} onChange={e=>setForm(f=>({...f,media_url:e.target.value}))} placeholder="https://cdn.example.com/ad.jpg" style={inp} />
              <div style={{marginTop:8,display:'flex',alignItems:'center',gap:10}}>
                <label style={{background:'rgba(212,168,67,0.15)',border:'1px solid '+border,borderRadius:6,padding:'8px 16px',color:gold,fontSize:12,cursor:uploading?'default':'pointer',opacity:uploading?0.6:1}}>
                  {uploading ? `UPLOADING... ${uploadProgress}%` : 'OR UPLOAD IMAGE FILE'}
                  <input type="file" accept="image/*,video/*" disabled={uploading} onChange={e=>handleFileUpload(e.target.files[0])} style={{display:'none'}} />
                </label>
                <span style={{color:'rgba(255,255,255,0.3)',fontSize:11}}>Uploads to your CDN automatically</span>
              </div>
            </div>
            <div><label style={lbl}>CLICK URL</label><input value={form.click_url} onChange={e=>setForm(f=>({...f,click_url:e.target.value}))} style={inp} /></div>
            <div><label style={lbl}>DURATION (seconds)</label><input type="number" value={form.duration_seconds} onChange={e=>setForm(f=>({...f,duration_seconds:parseInt(e.target.value)}))} style={inp} /></div>
            <div><label style={lbl}>MONTHLY RATE (₹, 0 = free/house ad)</label><input type="number" value={form.monthly_rate} onChange={e=>setForm(f=>({...f,monthly_rate:parseFloat(e.target.value)||0}))} placeholder="5000" style={inp} /></div>
            <div><label style={lbl}>EXPIRES ON</label><input type="date" value={form.expires_at} onChange={e=>setForm(f=>({...f,expires_at:e.target.value}))} style={inp} /></div>
            <div style={{display:'flex',alignItems:'center',gap:10}}><input type="checkbox" checked={form.is_active} onChange={e=>setForm(f=>({...f,is_active:e.target.checked}))} id="isActive" /><label htmlFor="isActive" style={{color:'#fff',fontSize:13}}>Active immediately</label></div>
          </div>
          {form.media_url && <div style={{marginTop:14}}><label style={lbl}>PREVIEW</label><img src={form.media_url} alt="preview" onError={e=>e.target.style.display='none'} style={{maxWidth:300,maxHeight:120,borderRadius:6,border:'1px solid '+border}} /></div>}
          <button onClick={handleSave} disabled={saving} style={{marginTop:16,background:gold,color:'#000',border:'none',borderRadius:6,padding:'10px 24px',fontFamily:"'Bebas Neue',sans-serif",fontSize:14,cursor:'pointer'}}>{saving?'SAVING...':'CREATE AD'}</button>
        </div>
      )}

      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20}}>
        {[{label:'Total Ads',value:ads.length,icon:'📢'},{label:'Active',value:ads.filter(a=>a.is_active).length,icon:'✅'},{label:'Impressions',value:ads.reduce((s,a)=>s+(a.impressions||0),0),icon:'👁'},{label:'Clicks',value:ads.reduce((s,a)=>s+(a.clicks||0),0),icon:'🖱'}].map(s=>(
          <div key={s.label} style={{background:'rgba(255,255,255,0.03)',border:'1px solid '+border,borderRadius:8,padding:'12px 16px'}}>
            <div style={{fontSize:20}}>{s.icon}</div>
            <div style={{color:gold,fontSize:20,fontFamily:"'Bebas Neue',sans-serif",marginTop:4}}>{s.value}</div>
            <div style={{color:'rgba(255,255,255,0.4)',fontSize:11}}>{s.label}</div>
          </div>
        ))}
      </div>

      {loading ? <div style={{textAlign:'center',color:'rgba(255,255,255,0.4)',padding:40}}>Loading...</div>
        : ads.length === 0 ? <div style={{textAlign:'center',color:'rgba(255,255,255,0.3)',padding:40,border:'1px dashed '+border,borderRadius:10}}>No ads yet. Click "+ NEW AD" to create one.</div>
        : <div style={{display:'flex',flexDirection:'column',gap:12}}>
          {ads.map(ad=>(
            <div key={ad.id} style={{background:'rgba(255,255,255,0.03)',border:'1px solid '+border,borderRadius:10,padding:16,display:'flex',gap:16,alignItems:'flex-start'}}>
              {ad.media_url
                ? <img src={ad.media_url} alt={ad.title} onError={e=>e.target.style.display='none'} style={{width:100,height:60,objectFit:'cover',borderRadius:6,border:'1px solid '+border,flexShrink:0}} />
                : <div style={{width:100,height:60,background:'rgba(255,255,255,0.05)',borderRadius:6,flexShrink:0,display:'flex',alignItems:'center',justifyContent:'center',fontSize:24}}>📢</div>
              }
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:6,flexWrap:'wrap'}}>
                  <span style={{color:'#fff',fontSize:14,fontWeight:600}}>{ad.title}</span>
                  <span style={{background:typeColors[ad.type]||'#555',color:'#fff',fontSize:10,padding:'2px 8px',borderRadius:3}}>{typeLabels[ad.type]||ad.type}</span>
                  <span style={{background:ad.is_active?'rgba(0,200,100,0.15)':'rgba(255,0,0,0.15)',color:ad.is_active?'#00cc66':'#ff4444',fontSize:10,padding:'2px 8px',borderRadius:3}}>{ad.is_active?'ACTIVE':'INACTIVE'}</span>
                </div>
                <div style={{color:'rgba(255,255,255,0.4)',fontSize:11,marginBottom:4}}>👁 {ad.impressions||0} | 🖱 {ad.clicks||0} | {ad.duration_seconds}s | expires {new Date(ad.expires_at).toLocaleDateString('en-IN')}</div>
                {ad.click_url && <div style={{color:'rgba(255,255,255,0.3)',fontSize:11}}>{ad.click_url.substring(0,60)}</div>}
              </div>
              <div style={{display:'flex',gap:8,flexShrink:0}}>
                <button onClick={()=>toggleActive(ad)} style={{background:ad.is_active?'rgba(255,0,0,0.15)':'rgba(0,200,100,0.15)',color:ad.is_active?'#ff4444':'#00cc66',border:'none',borderRadius:4,padding:'6px 12px',fontSize:11,cursor:'pointer'}}>{ad.is_active?'PAUSE':'ACTIVATE'}</button>
                <button onClick={()=>deleteAd(ad.id)} style={{background:'rgba(255,0,0,0.1)',color:'#ff4444',border:'none',borderRadius:4,padding:'6px 12px',fontSize:11,cursor:'pointer'}}>DELETE</button>
              </div>
            </div>
          ))}
        </div>
      }
    </div>
  );
}
